import { TFunction } from 'i18next';

import {
  BoardMineralization,
  BoardSoil,
  BoardStatus,
} from 'features/Croptimizer/types';
import { numericValues } from 'utils/helpers';
import { getEfficiencyFormula } from 'features/Croptimizer/utils/calcHelperBoard';

interface Props {
  getY3CurrentProfit?: string | number;
  mineralizationValues: BoardMineralization | null;
  boardStatusValues: BoardStatus | null;
  boardSoilValues: BoardSoil | null;
  optimumValue: number;
  t: TFunction;
}

export const Y4CurrentProfitSecond = ({
  getY3CurrentProfit,
  boardStatusValues,
  mineralizationValues,
  boardSoilValues,
  optimumValue,
  t,
}: Props) => {
  const getSec = (
    ((Math.tan((Number(getY3CurrentProfit) - 5.8) / 1.45) * 54 + 70) /
      100 /
      0.05) *
    5
  ).toFixed(2);

  const ag38 = getEfficiencyFormula(
    Number(mineralizationValues?.month),
    Number(boardStatusValues?.currentPh),
    Number(numericValues(boardStatusValues?.currentSec ?? '')),
    // Number(boardSoilValues?.selected),
    optimumValue,
    Number(numericValues(mineralizationValues?.soilTillage ?? '')),
  );
  const ah38 = getEfficiencyFormula(
    24,
    Number(getY3CurrentProfit),
    Number(getSec),
    // Number(boardSoilValues?.selected),
    optimumValue,
    Number(numericValues(mineralizationValues?.soilTillage ?? '')),
  );
  const ai38 = getEfficiencyFormula(
    36,
    Number(getY3CurrentProfit),
    Number(getSec),
    // Number(boardSoilValues?.selected),
    optimumValue,
    Number(numericValues(mineralizationValues?.soilTillage ?? '')),
  );
  const aj38 = getEfficiencyFormula(
    48,
    Number(getY3CurrentProfit),
    Number(getSec),
    // Number(boardSoilValues?.selected),
    optimumValue,
    Number(numericValues(mineralizationValues?.soilTillage ?? '')),
  );

  const ag31 = ag38;
  const ah31 = ah38 < ag31 ? ag31 : ah38;
  const ai78 = ah31 / 100;
  const ah78 = ag31 / 100;
  const ah79 = ag31 / 100;
  const ai71 = ai78 - ah78;
  const ah71 = ah78;
  const dose = Number(numericValues(boardSoilValues?.dose ?? '')) / 100;
  const ai79 = ah31 / 100;
  const ai31 = ai38 < ah31 ? ah31 : ai38;
  const aj78 = ai31 / 100;
  const aj71 = aj78 - ai78;
  const aj79 = ai31 / 100;
  const ai72 = ai79 - ah79;
  const aj31 = aj38 < ai31 ? ai31 : aj38;
  const ajj78 = aj31 / 100;
  const ak71 = ajj78 - aj78;
  const aj81 = ai31 / 100;
  const ak81 = aj31 / 100;
  const ak74 = ak81 - aj81;

  const ah80 = ag31 / 100;
  const ah73 = ah80;
  const aj80 = ai31 / 100;
  const ak80 = aj31 / 100;
  const ak73 = ak80 - aj80;

  const ak79 = aj31 / 100;
  const ak72 = ak79 - aj79;
  const aj82 = ai31 / 100;
  const ak82 = aj31 / 100;
  const ak75 = ak82 - aj82;
  const annualDecrease = Number(mineralizationValues?.annualDecrease);
  const frequency = Number(boardSoilValues?.split);

  if (mineralizationValues?.cap !== t('no')) {
    if (boardSoilValues?.split === '1') {
      const ak87 = ah71 + ai71 + aj71 + ak71;
      const calculatedq64 = (annualDecrease * dose * frequency * ak87).toFixed(
        2,
      );
      const p64MinusAnnual = Number(getY3CurrentProfit) - annualDecrease;

      return (p64MinusAnnual + Number(calculatedq64)).toFixed(2);
    }

    if (boardSoilValues?.split === '2') {
      const ak88 = ak72 + ai72;
      const calculatedq65 = (annualDecrease * dose * frequency * ak88).toFixed(
        2,
      );
      const p64MinusAnnual =
        Number(getY3CurrentProfit) - annualDecrease * (1 + 1 * 0.2);

      return (p64MinusAnnual + Number(calculatedq65)).toFixed(2);
    }

    if (boardSoilValues?.split === '3') {
      const ak89 = ah73 + ak73;
      const calculatedq65 = (annualDecrease * dose * frequency * ak89).toFixed(
        2,
      );
      const p64MinusAnnual = Number(getY3CurrentProfit) - annualDecrease;

      return (p64MinusAnnual + Number(calculatedq65)).toFixed(2);
    }

    if (boardSoilValues?.split === '4') {
      const ak90 = ak74;
      const calculatedq65 = (annualDecrease * dose * frequency * ak90).toFixed(
        2,
      );
      const p64MinusAnnual =
        Number(getY3CurrentProfit) - annualDecrease * (1 + 1 * 0.4);

      return (p64MinusAnnual + Number(calculatedq65)).toFixed(2);
    }

    if (boardSoilValues?.split === '5') {
      const ak91 = ak75;
      const calculatedq65 = (annualDecrease * dose * frequency * ak91).toFixed(
        2,
      );
      const p64MinusAnnual =
        Number(getY3CurrentProfit) - annualDecrease * (1 + 1 * 0.5);

      return (p64MinusAnnual + Number(calculatedq65)).toFixed(2);
    }
  } else {
    if (boardSoilValues?.split === '1') {
      const calculatedq64 = (annualDecrease * dose * frequency).toFixed(2);
      const p64MinusAnnual = Number(getY3CurrentProfit) - annualDecrease;

      return (p64MinusAnnual + Number(calculatedq64)).toFixed(2);
    }

    if (boardSoilValues?.split === '2') {
      const p64MinusAnnual =
        Number(getY3CurrentProfit) - annualDecrease * (1 + 1 * 0.2);

      return (p64MinusAnnual + 0).toFixed(2);
    }

    if (boardSoilValues?.split === '3') {
      const calculatedq64 = (annualDecrease * dose * frequency).toFixed(2);
      const p64MinusAnnual = Number(getY3CurrentProfit) - annualDecrease;

      return (p64MinusAnnual + Number(calculatedq64)).toFixed(2);
    }

    if (boardSoilValues?.split === '4') {
      const p64MinusAnnual =
        Number(getY3CurrentProfit) - annualDecrease * (1 + 1 * 0.4);

      return (p64MinusAnnual + 0).toFixed(2);
    }

    if (boardSoilValues?.split === '5') {
      const p64MinusAnnual =
        Number(getY3CurrentProfit) - annualDecrease * (1 + 1 * 0.5);

      return (p64MinusAnnual + 0).toFixed(2);
    }
  }
};
